import React from 'react'
import './Explore-btn.css'
import { Link } from 'react-router-dom'

const Explore_btn = (props) => {
  return (
    <section className='Explore_btn_div'>
      {props.link ? (
        <Link to={props.link}>
          <button className='explore_btn'>
            <span>{props.name}</span>
          </button>
        </Link>
      ) : (
        <button className='explore_btn' onClick={props.onClick}>
          <span>{props.name}</span>
        </button>
      )}
    </section>
  );
};


export default Explore_btn